import { TextInput } from "components/core";
import { FormikProps } from "formik";
import _ from "lodash";
import { FC } from "react";

export interface CreateLimitFormProps {
  form: FormikProps<any>;
}

const CreateLimitForm: FC<CreateLimitFormProps> = ({ form }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className="pt-3">
        <div className="grid grid-cols-2 gap-2">
          <div className="col-span-2">
            <TextInput
              type="number"
              id="participationLowerLimit"
              label="Participation Lower Limit (%)"
              placeholder="Participation Lower Limit"
              required={true}
              {...form}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateLimitForm;
